  export const environment = {
    production: false,
    serverUrl: 'https://f2452sn5w2.execute-api.us-east-2.amazonaws.com/dev',
    tokenEndpoint: 'https://auth.verge.bdataredthread.com/oauth2/token',
    redirectUrl: 'https://verge.bdataredthread.com',
    managedLoginUrl: 'https://auth.verge.bdataredthread.com/login',
    bucket: 'cutpointoidc-prod-upload',
    userPool: {
      UserPoolId: 'us-east-2_GUglHjTQM',
      ClientId: '7qn0hiuaa0girtg0lornq3m1el',
      region: 'us-east-2'
    },
    identityPoolId: 'us-east-2:8d71cff8-2bd8-4b7a-aa2b-97c9d46f8aa1',
    buckets: {
      'us-east-2': 'cutpointoidc-prod-upload'
    },
    defaultRegion: 'us-east-2',
    cognito: {
      identityPoolId:'us-east-2:8d71cff8-2bd8-4b7a-aa2b-97c9d46f8aa1', //REQUIRED - Amazon Cognito Identity Pool ID
      region: 'us-east-2', // REQUIRED - Amazon Cognito Region
      userPoolId: 'us-east-2_GUglHjTQM', //OPTIONAL - Amazon Cognito User Pool ID
      userPoolWebClientId: '7qn0hiuaa0girtg0lornq3m1el', //OPTIONAL - Amazon Cognito Web Client ID
    },
    Storage: {
      AWSS3: {
        bucket: 'cutpointoidc-prod-upload', //REQUIRED -  Amazon S3 bucket
        region: 'us-east-2', //OPTIONAL -  Amazon service region
      }
    }
  };

const awsconfig = {
  Auth: {
    Cognito: {
      userPoolClientId: '7qn0hiuaa0girtg0lornq3m1el',
      userPoolId: 'us-east-2_GUglHjTQM',
      identityPoolId: 'us-east-2:8d71cff8-2bd8-4b7a-aa2b-97c9d46f8aa1'
    }
  },
  Storage: {
    S3: {
      bucket: 'cutpointoidc-prod-upload',
      region: 'us-east-2'
    }
  }
};
export default awsconfig;